import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FieldsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",

  "& .MuiBox-root": {
    display: "flex",
    gap: "10px",

    "&>div": {
      width: "100%",
    },
  },
});
